export default "__VITE_ASSET__f9676248__"